export const createMenuLinks = (
  url,
  {
    isNetworkAdmin,
    showPlansAndBillings,
    showAccountNotifications,
    isNotOnlyCompanyAdmin,
    hasJobBoard = true,
    isOnlyAlly,
  },
) => [
  ...(isNetworkAdmin
    ? [
        {
          title: 'Network',
          items: [
            { title: 'General', path: `${url}/general` },
            ...(isOnlyAlly ? [] : [{ title: 'Team members', path: `${url}/team-members` }]),
            ...(showPlansAndBillings ? [{ title: 'Plans and billing', path: `${url}/plans-and-billing` }] : []),
            { title: 'API keys', path: `${url}/api-keys` },
          ],
        },
      ]
    : []),
  ...(isNetworkAdmin && hasJobBoard
    ? [
        {
          title: 'Job board',
          items: [
            { title: 'General', path: `${url}/job-board` },
            { title: 'Talent network', path: `${url}/job-board-talent-network` },
            { title: 'Filters', path: `${url}/job-board-filters` },
            { title: 'Job rules', path: `${url}/job-board-rules` },
            { title: 'Privacy policy', path: `${url}/job-board-privacy-policy` },
            { title: 'Data export', path: `${url}/data-export` },
          ],
        },
      ]
    : []),
  {
    title: 'My account',
    items: [
      ...(isNotOnlyCompanyAdmin
        ? [
            { title: 'My networks', path: `${url}/my-networks` },
            { title: 'Personal integrations', path: `${url}/integrations` },
          ]
        : []),
      { title: 'Profile', path: `${url}/account-my-profile` },
      ...(showAccountNotifications ? [{ title: 'Notifications', path: `${url}/account-notifications` }] : []),
      { title: 'Account', path: `${url}/account-my-account` },
    ],
  },
];
